import {WidgetConfig} from "../types/config";

declare const CONFIG_PATH: string;

export default class ConfigLoader {

    private static instance: WidgetConfig;

    static async getConfig() {
        if (!this.instance) {
            this.instance = await this.load();
        }
        return this.instance;
    }

    static async load(  ): Promise<WidgetConfig> {
        const module = await import(CONFIG_PATH);
        const Config = module.default;
        return new Config();
    }
}